


















import {Component, Prop, Vue} from 'vue-property-decorator';
import { EventItem } from '@/store/models';
import user from '@/store/modules/user';

@Component
export default class StartSieItem extends Vue {
    @Prop() event: EventItem | undefined;

    async gotoItem() {
        if (!this.event) {
            return;
        }
        await user.setActiveExternalUser(null);
        await user.setSelectedSie(this.event.Id);
        await user.setSelectedSieBlob(null);
        const OrgNr: string = this.event.OrgNr;
        this.$router.push({ name: 'sie', params: { OrgNr } });
    }

    get documentType() {
        if (this.isUpdated) {
            return 'Redigerad SIE-import';
        }
        return 'SIE-import';
    }

    get isUpdated(): boolean {
        if (!this.event) {
            return false;
        }
        return this.event.Updated;
    }

    get period() {
        if (!this.event) {
            return '';
        }
        return `${this.event.PeriodStart.substr(0, 7)} till ${this.event.PeriodEnd.substr(0, 7)}`;
    }
}
